const audioList = {
    start:'https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/prod.mp3',
    love:'https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/cityLove.mp3'
}

export default (type,create,id,loop)=>{
    var audio = document.createElement('audio');
    if(create){
        audio.id = id
        document.body.appendChild(audio)
    }
    audio.src = audioList[type];
    audio.loop = loop
    audio.play();
    audio = null;
}

// {
//     getAudio:function(){

//     },
//     play:,
//     pause:
// }